export default __webpack_public_path__ + "static/media/pinterest_tall.0a5b5a94.png";